/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './text.scss';
import './modifier/color.scss';
import './modifier/alignment.scss';
import './modifier/type.scss';
import './modifier/style.scss';
import './modifier/max-width.scss';
import './modifier/basic-rte.scss';
import './modifier/rotate.scss';
